import { connect } from "react-redux";
import colores from "../../shared/constants/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect } from "react";

interface ConsultarDisponibilidadProps {
  producto: string;
  open: boolean;
  handleConfirm: () => void;
}

const ConsultarDisponibilidad = (props: ConsultarDisponibilidadProps) => {
  useEffect(() => {}, [props.open]);

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Disponibilidad del producto {props.producto}.
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Por favor, verificá con tu ejecutivo la disponibilidad del producto.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button
          className="btn btn-danger"
          type="button"
          onClick={props.handleConfirm}
          style={{
            backgroundColor: colores.rojo,
            padding: "0.625rem",
            marginTop: "1.25rem",
            inlineSize: "10rem",
            marginLeft: "1rem",
          }}
        >
          Continuar
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default connect()(ConsultarDisponibilidad);
